import React from "react";
import PropTypes from "prop-types";

import Row from "../../../common/Row";
import Button from "../../../common/Button";
import TextInput from "../../../common/TextInput";
import AutoComplete from "../../../common/AutoComplete";
import ConfirmModal from "../../../common/ConfirmModal";
import SelectInput from "../../../common/SelectInput";
import { orderByPropertyName } from "../../../../util/orderBy.js";

const GemeenteOverzichtFilterForm = (props) => {
    const {
        filter,
        onExportSportclubs,
        onLink,
        onChange,
        onSearch,
        onScrollToAanvragen,
        onOpenExportModal,
        onCloseExportModal,
        exportModalIsOpen,
        gemeenteEmailAdres,
        nameFilterHasFocus,
        sportdomeinen,
        sportinfras,
        sporttakken,
        onToonKaart,
        overzichtSportInfrastructurenLink
    } = props;

    function handleOnExportSportclubs() {
        return function (event) {
            onExportSportclubs(event);
        };
    }

    function handleOnOpenExportModal() {
        return function (event) {
            onOpenExportModal(event);
        };
    }

    function handleOnCloseExportModal() {
        return function (event) {
            onCloseExportModal(event);
        };
    }

    const exportModalText = <p>Verzend mij een export van alle sportclubs en verstuur dit naar het onderstaande e-mailadres.<br />Je zal binnen de 30 minuten een mail ontvangen met de lijst van jouw sportclubs.</p>;

    const buttonStyle = { marginLeft: ".83333%", marginRight: ".83333%" };

    const hasVCode = filter.vCode && filter.vCode.length > 0;
    const hasOndernemingsnummer = filter.ondernemingsnummer && filter.ondernemingsnummer.length > 0;
    const hasNaam = filter.naam && filter.naam.length > 0;
    const hasSportdomein = filter.sportdomein && filter.sportdomein > 0;
    const hasSporttak = filter.sporttak && filter.sporttak.length > 0;
    const hasSportInfrastructuur = filter.sportinfrastructuur && filter.sportinfrastructuur.length > 0;

    return (
        <div>
            {exportModalIsOpen && <ConfirmModal
                isOpen={exportModalIsOpen}
                mainText={exportModalText}
                confirmAction={handleOnExportSportclubs()}
                cancelAction={handleOnCloseExportModal()}
                confirmText="Ga verder"
                cancelText="Annuleer"
                inputValue={gemeenteEmailAdres}
                inputName={"gemeenteEmailAdres"}
                inputLabel="e-mailadres"
                onChange={onChange}
                title="Exporteer alle sportclubs"
            />}

            <Row>
                <Button onClick={onScrollToAanvragen} text="Openstaande aanvragen" className="c-button--small o-col-2 c-input" style={buttonStyle} />
                <div className="o-col-1" style={{ margin: "1px", marginLeft: ".83333%", marginRight: ".83333%" }}></div>
                <a target="_blank" href={overzichtSportInfrastructurenLink}><Button text="Overzicht sportinfrastructuren" className="c-button--small o-col-3 c-input" style={buttonStyle} /></a>
                <Button onClick={onToonKaart} text="Kaart met sportclubs" className="c-button--small o-col-2 c-input" style={buttonStyle} />
                <Button onClick={handleOnOpenExportModal()} text="Exporteer alle sportclubs" className="c-button--small o-col-2 c-input" style={buttonStyle} />
                <Button onClick={onLink} text="Sportclub melden" className="c-button--small o-col-2 c-input" style={buttonStyle} />
            </Row>

            <Row>
                <TextInput
                    name="naam"
                    label="Naam"
                    value={filter.naam}
                    size={6}
                    onChange={onChange}
                    disabled={hasVCode || hasOndernemingsnummer}
                    hasFocus={nameFilterHasFocus}
                    onEnter={onSearch}
                />
                <AutoComplete
                    allowFullListSelect
                    items={orderByPropertyName(sportdomeinen, "label")}
                    size={6}
                    name="sportdomein"
                    label="Sportdomein"
                    value={filter.sportdomein}
                    onChange={onChange}
                    useDefaultItem
                    disabled={!sportdomeinen.length || hasVCode || hasOndernemingsnummer}
                    clearable
                    onEnter={onSearch}
                />
            </Row>
            <Row>
                <AutoComplete
                    allowFullListSelect
                    items={sporttakken}
                    size={6}
                    name="sporttak"
                    label="Sporttak"
                    value={filter.sporttak}
                    onChange={onChange}
                    useDefaultItem
                    clearable
                    onEnter={onSearch}
                    disabled={hasVCode || hasOndernemingsnummer}

                />
                <SelectInput
                    items={filter.sportdomein ? orderByPropertyName(sportinfras.filter(x => x.domeinId.toString() === filter.sportdomein.toString()), "label") : []}
                    size={6}
                    name="sportinfrastructuur"
                    label="Sportinfrastructuur"
                    value={filter.sportinfrastructuur}
                    onChange={onChange}
                    useDefaultItem={false}
                    disabled={!filter.sportdomein || hasVCode || hasOndernemingsnummer}
                />
            </Row>
            <Row>
                <TextInput
                    name="ondernemingsnummer"
                    label="Ondernemingsnummer"
                    value={filter.ondernemingsnummer}
                    size={6}
                    onChange={onChange}
                    disabled={hasVCode || hasSportInfrastructuur || hasNaam || hasSporttak || hasSportInfrastructuur || hasSportdomein}
                    onEnter={onSearch}
                />
                <TextInput
                    name="vCode"
                    label="V-Code"
                    value={filter.vCode}
                    size={6}
                    onChange={onChange}
                    disabled={hasOndernemingsnummer || hasNaam || hasSporttak || hasSportInfrastructuur || hasSportdomein}
                    onEnter={onSearch}
                />
            </Row>
            <Row>
                <Button style={{ marginLeft: '.83333%', paddingLeft: '1.1em', float: "right" }} onClick={onSearch} text="Zoek" className="o-col-1 c-input" />
            </Row>
        </div>
    );
};

GemeenteOverzichtFilterForm.propTypes = {
    filter: PropTypes.object,
    onExportSportclubs: PropTypes.func,
    onLink: PropTypes.func,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    onScrollToAanvragen: PropTypes.func,
    onOpenExportModal: PropTypes.func,
    onCloseExportModal: PropTypes.func,
    exportModalIsOpen: PropTypes.bool,
    gemeenteEmailAdres: PropTypes.string,
    nameFilterHasFocus: PropTypes.bool,
    sporttakken: PropTypes.array,
    sportdomeinen: PropTypes.array,
    sportinfras: PropTypes.array,
    onToonKaart: PropTypes.func,
    overzichtSportInfrastructurenLink: PropTypes.string
};

export default GemeenteOverzichtFilterForm;